import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"404"}},[_c(VContainer,{attrs:{"fluid":"","fill-height":""}},[_c(VLayout,{attrs:{"align-center":"","justify-center":""}},[_c('div',{staticClass:"text-md-center"},[_c('h1',[_vm._v("404")]),_c('h2',{staticClass:"my-3 headline"},[_vm._v("Sorry, page not found")]),_c('div',[_c(VBtn,{attrs:{"color":"primary"},on:{"click":_vm.goHome}},[_vm._v("Go Home")])],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }